(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/expanded-systems/assets/javascripts/expanded-systems.js') >= 0) return;  svs.modules.push('/components/sport/expanded-systems/assets/javascripts/expanded-systems.js'); 'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var logger = svs.core.log.getLogger('sport:expanded_systems');
var _svs$sport$expandedSy = svs.sport.expandedSystems,
    SYSTEMS = _svs$sport$expandedSy.SYSTEMS,
    systemNumMapping = _svs$sport$expandedSy.systemNumMapping;
var currentSystem, rowModel, viewEl;

var getExpandedRowsView = function getExpandedRowsView(system, row, urows, isExpandedSystems) {
  if (!rowModel || !rowModel.length || currentSystem !== system) {
    try {
      currentSystem = system;

      if (isExpandedSystems) {
        rowModel = {
          rows: convertBitmapRowsToReadable(row)
        };
      } else {
        rowModel = {
          rows: getExpandedRows(system, row, urows)
        };
      }

      var base64Rows = '';
      var rowsLength = rowModel.rows.length;

      for (var i = 0; i < rowsLength; ++i) {
        base64Rows += rowModel.rows[i].join('\r\n');
        base64Rows += '\r\n';
      }

      rowModel.base64Rows = window.btoa(base64Rows);
    } catch (e) {
      logger.error('Error expanding rows. ', e);
    }
  }

  var divTag = document.createElement('div'),
      innerDivTag = document.createElement('div');
  innerDivTag.className = 'expanded-rows-wrap';
  divTag.appendChild(innerDivTag);
  divTag.className = 'expanded-rows bg-white padding-top-1 padding-bottom-1 padding-left-2 padding-right-2 grid-row';
  viewEl = $(innerDivTag);

  if (isExpandedSystems) {
    viewEl.prepend('<div class="f-600 f-bold f-prominent padding-bottom-1">Dina rader</div>');
  }

  window.requestIdleCallback(addRowsToView);
  return divTag;
};

function splitBombenBoardDataToRows(boardData, rSysData) {
  var rowLength = boardData.length;

  var propagateIndicies = function propagateIndicies(rowIndex) {
    if (rowIndex === rowLength) {
      return;
    }

    markIndicies[rowIndex] += 1;

    if (markIndicies[rowIndex] === boardData[rowIndex].length) {
      markIndicies[rowIndex] = 0;
      propagateIndicies(rowIndex + 1);
    }
  };

  var totalRows = boardData.map(function (marks) {
    return marks.length;
  }).reduce(function (acc, numMarks) {
    return acc * numMarks;
  }, 1);
  var nonReducedRows = [];
  var markIndicies = {};

  for (var i = 0; i < rowLength; ++i) {
    markIndicies[i] = 0;
  }

  for (var _i = 0; _i < totalRows; ++_i) {
    var row = [];

    for (var x = 0; x < rowLength; ++x) {
      var markIndex = markIndicies[x];
      row.push(boardData[x][markIndex]);
    }

    propagateIndicies(0);
    nonReducedRows.push(row);
  }

  if (!rSysData) {
    return nonReducedRows;
  }

  var reducedRows = nonReducedRows.filter(function (row) {
    for (var _i2 = 0; _i2 < row.length; _i2 += 2) {
      var rSys = rSysData[_i2 / 2];

      if (rSys.indexOf('HOME') === -1) {
        if (Number(row[_i2]) > Number(row[_i2 + 1])) {
          return false;
        }
      }

      if (rSys.indexOf('DRAW') === -1) {
        if (row[_i2] === row[_i2 + 1]) {
          return false;
        }
      }

      if (rSys.indexOf('AWAY') === -1) {
        if (Number(row[_i2]) < Number(row[_i2 + 1])) {
          return false;
        }
      }
    }

    return true;
  });
  return reducedRows;
}

function splitBombenExpertenBoardDataToRows(boardData) {
  var rows = splitBombenBoardDataToRows(boardData);
  return rows.map(function (row) {
    return row.reduce(function (acc, value) {
      return [].concat(_toConsumableArray(acc), [value[0], value[1]]);
    }, []);
  });
}

var addRowsToView = function addRowsToView(opt) {
  if (rowModel.rows.length) {
    var row = rowModel.rows.shift();

    while (row) {
      viewEl.append("<ul class=\"left expanded-rows-list\"><li>".concat(row.join('</li><li>'), "</li></ul>"));

      if (opt.timeRemaining() > 0) {
        row = rowModel.rows.shift();
      } else {
        row = null;
        window.requestIdleCallback(addRowsToView);
      }
    }
  }
};


var getExpandedRows = function getExpandedRows(system, row, uRows) {
  if (typeof system !== 'string' && typeof system !== 'number') {
    logger.error("First parameter must be of type string or number, ".concat(_typeof(system), " given"));
    return;
  }

  if (!Array.isArray(row)) {
    logger.error("Second parameter must be array, ".concat(_typeof(row), " given"));
    return;
  }

  var marks = [],
      currentRow = JSON.parse(JSON.stringify(row)),
      currentRowLength = currentRow.length;
  var rowsToProcess = [],
      processedRows = [],
      rowsToProcessLength = 0;

  for (var i = 0; i < currentRowLength; i++) {
    if (currentRow[i].indexOf('M') !== -1) {
      marks.push({
        position: i,
        marks: currentRow[i].substr(0, currentRow[i].length - 1)
      });
    }
  }

  if (marks.length) {
    rowsToProcess = getMathRows(currentRow, 0, marks);
  } else {
    rowsToProcess.push(currentRow);
  }

  rowsToProcessLength = rowsToProcess.length;

  for (var _i3 = 0; _i3 < rowsToProcessLength; ++_i3) {
    processedRows = processedRows.concat(getExpandedRowsFromSingleRow(typeof system === 'number' ? systemNumMapping[system] : system, rowsToProcess[_i3], uRows));
  }

  return processedRows;
};


var getMathRows = function getMathRows(row, currentMark, marks) {
  var combinedRows = [];

  if (marks.length === currentMark) return [];

  var currentMarkLength = marks[currentMark].marks.length;

  for (var i = 0; i < currentMarkLength; ++i) {
    row[marks[currentMark].position] = marks[currentMark].marks[i];

    if (currentMark === marks.length - 1) {
      combinedRows.push(JSON.parse(JSON.stringify(row)));
    }


    combinedRows = combinedRows.concat(getMathRows(row, currentMark + 1, marks));
  }

  return combinedRows;
};

var splitToRows = function splitToRows(row) {
  if (!Array.isArray(row)) {
    row = [];
  }

  var marks = [];
  var rows = [];

  for (var i = 0; i < row.length; ++i) {
    if (row[i].length > 1) {
      marks.push({
        position: i,
        marks: row[i]
      });
    }
  }

  if (marks.length) {
    rows = getMathRows(row.slice(0), 0, marks);
  } else {
    rows = row;
  }

  return rows;
};


var getExpandedRowsFromSingleRow = function getExpandedRowsFromSingleRow(system, row, urows) {
  var fullHedgesIndices = [],
  halfHedgesIndices = [],
  singlesIndices = [],
  expandedRows = [],
      rowLength = row.length,
      marks = ['1', 'X', '2'],
      halfMarks = {
    '1X': ['1', 'X'],
    12: ['1', '2'],
    X2: ['X', '2']
  },
      uMarks = {
    1: ['1', 'X', '2'],
    X: ['X', '1', '2'],
    2: ['2', '1', 'X']
  },
      uHalfMarks = {
    1: {
      '1X': ['1', 'X'],
      12: ['1', '2']
    },
    X: {
      '1X': ['X', '1'],
      X2: ['X', '2']
    },
    2: {
      12: ['2', '1'],
      X2: ['2', 'X']
    }
  },
      systemRows = SYSTEMS[system],
      isUSystem = systemRows.systemType === 'U'; 

  var currentFullIndex = null,
      currentHalfIndex = null;

  if (typeof systemRows === 'undefined') {
    logger.error("Failed to find a system with name: ".concat(system));
    return;
  }


  for (var i = 0; i < rowLength; ++i) {
    if (row[i].length === 3) {
      fullHedgesIndices.push(i);
    } else if (row[i].length === 1) {
      singlesIndices.push(i);
    } else {
      halfHedgesIndices.push(i);
    }
  }

  var systemRowsLength = systemRows.rows.length,
      fullHedgesIndicesLength = fullHedgesIndices.length,
      halfHedgesIndicesLength = halfHedgesIndices.length;

  for (var _i4 = 0; _i4 < systemRowsLength; ++_i4) {
    currentFullIndex = -1;
    currentHalfIndex = fullHedgesIndicesLength - 1;
    expandedRows.push([]);

    for (var k = 0; k < fullHedgesIndicesLength; ++k) {
      if (isUSystem) {
        expandedRows[expandedRows.length - 1][fullHedgesIndices[k]] = uMarks[urows[fullHedgesIndices[k]]][systemRows.rows[_i4][++currentFullIndex]];
      } else {
        expandedRows[expandedRows.length - 1][fullHedgesIndices[k]] = marks[systemRows.rows[_i4][++currentFullIndex]];
      }
    }

    for (var _k = 0; _k < halfHedgesIndicesLength; ++_k) {
      if (isUSystem) {
        expandedRows[expandedRows.length - 1][halfHedgesIndices[_k]] = uHalfMarks[urows[halfHedgesIndices[_k]]][row[halfHedgesIndices[_k]]][systemRows.rows[_i4][++currentHalfIndex]];
      } else {
        expandedRows[expandedRows.length - 1][halfHedgesIndices[_k]] = halfMarks[row[halfHedgesIndices[_k]]][systemRows.rows[_i4][++currentHalfIndex]];
      }
    }


    for (var _k2 = 0; _k2 < singlesIndices.length; ++_k2) {
      expandedRows[expandedRows.length - 1][singlesIndices[_k2]] = row[singlesIndices[_k2]];
    }
  }

  return expandedRows;
};

var convertBitmapRowsToReadable = function convertBitmapRowsToReadable(bitmapRows) {
  if (!Array.isArray(bitmapRows)) {
    logger.error('Parameter bitmapRows is not an array');
    return;
  }

  var bitmaps = ['1', 'X', '1X', '2', '12', 'X2', '1X2'],
      readableRows = [],
      bitmapsRowsLength = bitmapRows.length;

  for (var i = 0; i < bitmapsRowsLength; ++i) {
    var row = [];

    for (var k = 0; k < bitmapRows[i].length; ++k) {
      var char = bitmapRows[i][k].toLowerCase(); 

      if (isNaN(parseInt(char, 10)) || char === 'd' || char === '0') {
        continue;
      }

      row.push(bitmaps[char - 1]);
    }

    readableRows.push(row);
  }

  return readableRows;
};

var getDownloadButton = function getDownloadButton() {
  var aTag = document.createElement('a');
  aTag.className = 'btn btn-300 btn-default js-expanded-rows-dwlnld-btn';
  aTag.innerHTML = '<span class="btn-link-text">Ladda ned fil</span>';
  aTag.href = "data:application/octet-stream;charset:UTF-8;base64,".concat(rowModel.base64Rows);
  aTag.download = 'mina_rader.txt';
  return aTag;
};


var getDistribution = function getDistribution(rows) {
  var distribution = [];
  var matchCount;
  if (rows.length > 0) matchCount = rows[0].length;

  for (var i = 0; i <= matchCount; ++i) {
    distribution.push({
      1: 0,
      X: 0,
      2: 0
    });
  }

  rows.forEach(function (row) {
    row.forEach(function (mark, matchIndex) {
      if (mark.toUpperCase() === '1') {
        return ++distribution[matchIndex]['1'];
      }

      if (mark.toUpperCase() === 'X') return ++distribution[matchIndex].X;

      if (mark.toUpperCase() === '2') {
        return ++distribution[matchIndex]['2'];
      }
    });
  });
  distribution.forEach(function (dist) {
    dist['1'] = Math.round(dist['1'] / rows.length * 100);
    dist.X = Math.round(dist.X / rows.length * 100);
    dist['2'] = Math.round(dist['2'] / rows.length * 100);
  });
  return distribution;
};


var expandMSYS = function expandMSYS(boards) {
  boards = convertBitmapRowsToReadable(boards);
  var singleRows = [];

  var _loop = function _loop(i) {
    boards[i].forEach(function (mark, k) {
      if (mark === '1X' || mark === 'X2' || mark === '12') {
        mark = mark.split('');
        boards[i][k] = mark[0];
        var additionalBoard = [];

        for (var j = 0; j < boards[i].length; j++) {
          if (j === k) additionalBoard[j] = mark[1];else additionalBoard[j] = boards[i][j];
        }

        boards.push(additionalBoard);
      }

      if (mark === '1X2') {
        mark = mark.split('');
        boards[i][k] = mark[0];
        var additionalBoardX = [],
            additionalBoard2 = [];

        for (var _j = 0; _j < boards[i].length; _j++) {
          if (_j === k) {
            additionalBoardX[_j] = mark[1];
            additionalBoard2[_j] = mark[2];
          } else {
            additionalBoardX[_j] = boards[i][_j];
            additionalBoard2[_j] = boards[i][_j];
          }
        }

        boards.push(additionalBoardX);
        boards.push(additionalBoard2);
      }
    });
    singleRows.push(boards[i]);
  };

  for (var i = 0; i < boards.length; i++) {
    _loop(i);
  }

  return singleRows;
};

svs.sport.expandedSystems = {
  getExpandedRowsView: getExpandedRowsView,
  convertBitmapRowsToReadable: convertBitmapRowsToReadable,
  getDownloadButton: getDownloadButton,
  getExpandedRows: getExpandedRows,
  getDistribution: getDistribution,
  splitToRows: splitToRows,
  expandMSYS: expandMSYS,
  SYSTEMS: SYSTEMS,
  systemNumMapping: systemNumMapping,
  splitBombenExpertenBoardDataToRows: splitBombenExpertenBoardDataToRows,
  splitBombenBoardDataToRows: splitBombenBoardDataToRows
};
 })(window);